import { useCustomerWithId } from "../../customers/useCustomerWithId";

export interface CustomerContact {
  readonly name: string;
  readonly email: string | null;
  readonly loginEmail: string | null;
}

export function useCustomerContacts(customerId: string | null | undefined): {
  isLoading: boolean;
  isError: boolean;
  contacts: CustomerContact[];
} {
  const { customer, isLoading, isError } = useCustomerWithId(customerId ?? undefined);
  if (!customer || isError) {
    return { isLoading, isError, contacts: [] };
  }
  return {
    isLoading,
    isError,
    contacts:
      customer.contacts
        ?.map((c) => ({
          name: c.name ?? c.email ?? "",
          email: c.email ?? null,
          loginEmail: c.loginEmail ?? null,
        }))
        .filter((c) => !!c.name) ?? [],
  };
}
